import { Heuristic } from '../../jscaip/AI/Heuristic';
export class EpaminondasHeuristic extends Heuristic {
}
